

<template>

<div class="ui segments" >
    <div class="ui segment">
        <div class="ui breadcrumb">
            <router-link :to="{name:'home'}" class="section">Sākums</router-link>
            <span class="divider">/</span>
            <div class="active section">Mani Autoship pasūtījumi</div>
        </div>
    </div>
    <div class="ui segment" v-if="list.length == 0" v-bind:class="{ loading: storeStatus.loading }">
        <div class="ui icon message">
            <img class="ui image small" src="../assets/autoship_logo.png" />
            <div class="content">
                <div class="header">
                    Vēlies ietaupīt laiku un naudu?
                </div>
                <p>Izveido regulāru AutoShip pasūtījumu un iegūsti atlaidi katram pasūtījumam.</p>
                <button @click="newAutoship" class="ui  green button"><i class="icon plus"></i>Pievienot AutoShip</button>
            </div>
        </div>
    </div>
    <div v-if="list.length > 0" class="ui segment" v-bind:class="{ loading: storeStatus.loading }" >
        <table class="ui selectable table orange">

            <thead>
                <tr>
                    <th>Nosaukums</th>
                    <th>Adrese</th>
                    <th>Regularitāte</th>
                    <th>Nākošais pasūtījums</th>
                    <th>Statuss</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in list" v-bind:class="{ warning: item.status == 0 }">

                    <td>{{item.autoship_name}}</td>
                    <td>{{item.address}}</td>
                    <td>Reizi <span v-if="item.frequency>1">{{item.frequency}} nedēļās</span><span v-else>nedēļā</span>, {{localDay(item.delivery_day)}}</td>
                    <td v-if="item.next_order">{{item.next_order.delivery_date}}</td>
                    <td v-else >n/a</td>
                    <td v-if="item.status == 1"><i class="icon checkmark"></i> Aktīvs</td>
                    <td v-else><i class="warning attention icon"></i> Neaktīvs</td>
                    <td>
                        <button v-if="item.lock == 0" v-on:click="goToEditPage(item)" class="ui  green button">Rediģēt</button>
                        <button v-if="item.lock == 0" v-on:click="removeItem(item)" class="ui grey icon button">
                        <i class="right trash icon"></i>
                      </button>
                      <button v-else v-on:click="goToEditPage(item)" class="ui  green button">Apskatīt</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <button @click="newAutoship" class="ui right floated green button"><i class="icon plus"></i>Pievienot AutoShip</button>
        <div class="ui clearing hidden divider"></div>
    </div>

    <!-- delete prompt -->
    <div id="autoship-delete-dialog" class="ui basic modal">
      <div class="ui icon header">
        <i class="trash icon"></i>
        Vai dzēst ierakstu?
      </div>
      <div class="content">
        <p>Dzēšot AutoShip ierakstu, visi nākotnes pasūtījumi tiks atcelti izņemot pasūtījumi, kas jau ir nodoti piegādei!</p>
      </div>
      <div class="actions">
        <div class="ui grey basic cancel inverted button">
          <i class="remove icon"></i>
          Nē
        </div>
        <div class="ui custom_brown ok inverted button" @click="deleteAutoship">
          <i class="checkmark icon"></i>
          Jā
        </div>
      </div>
    </div>

</div>

</template>

<script>

export default {

    data() {
      return {
        itemForDelete:false
      }
    },

    computed: {
        storeStatus() {
                return this.$store.state.autoShipStore.status
            },
            list() {
                return this.$store.state.autoShipStore.list;
            }
    },

    activated() {
        this.$store.dispatch('loadAutoship');
        this.$store.dispatch('loadOrderWaitingForDelivery'); //it could be that new order is created so we need to update this info to show on top menu
    },

    methods: {

      localDay(day){
        var days = ['','pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piekdienā', 'sestdienā', 'svētdienā']
        return days[day];
      },

        goToEditPage(item) {

          this.$store.commit('SET_AUTOSHIP_DETAILS', [])
          this.$store.dispatch('cloneAutoship',item.id).then((response) => {

            this.$router.push({
                name: 'autoship-edit',
                params: {
                    id: response.data.data.id
                }
            });

          }).catch((error) => {
            console.error(error)
            console.error('Autoship copy failed')
          });


        },

        newAutoship(){
              //clear previous data
              this.$store.commit('SET_AUTOSHIP_DETAILS', [])
              this.$store.dispatch('addAutoship').then((response) => {
                this.$router.push({
                    name: 'autoship-edit',
                    params: {
                        id: response.data.data.id
                    }
                });
              }).catch((error) => {
                console.error(error)
                console.error('Autoship creation failed')
              });
        },
        //show dialog and pass item to "delete" so that callback can handle it
        removeItem(item){

          this.itemForDelete = item
          $('#autoship-delete-dialog')
            .modal('show')
          ;

        },

        deleteAutoship(){

          this.$store.dispatch('deleteAutoship',this.itemForDelete).then((response) => {
            this.itemForDelete = ""
            this.$store.dispatch('loadOrderWaitingForDelivery');
          }).catch((error) => {
            console.error(error)
            console.error('Autoship deletion failed')
          });

        }
    },
}

</script>



// WEBPACK FOOTER //
// AutoshipPage.vue?3956e232